import { Injectable } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

@Injectable()
export class VCodeService {
  public countdownStatus = 'initial'; // initial-初始状态 pending-请求发送验证码中 countdown-倒计时中
  public countdownTime = 0;
  public imageCodeUrl = '';
  public imageCodeUuid = '';

  constructor(public daoService: DaoService) {}

  public sendVerifiedCode(options: any) {
    if (this.countdownStatus === 'initial') {
      this.countdownStatus = 'pending';
      this.daoService
        .sendVerifiedCode(options.phone, options.imgCode, this.imageCodeUuid)
        .then(() => {
          this.countdownTime = 60;
          this.countdownStatus = 'countdown';
          this.ticktok();
        })
        .catch(e => {
          this.countdownStatus = 'initial';
          // 获取报错之后，需要自动清除并更新imgaeCode
          options.errFun && options.errFun();
          throw e;
        });
    } else {
      return Promise.resolve();
    }
  }

  public ticktok() {
    if (this.countdownTime > 0 && this.countdownTime <= 60) {
      this.countdownTime--;
      setTimeout(() => {
        this.ticktok();
      }, 1000);
    } else {
      this.countdownTime = 0;
      this.countdownStatus = 'initial';
    }
  }

  public getImageCode() {
    this.daoService
      .getCaptcha()
      .then(data => {
        this.imageCodeUrl = data.img;
        this.imageCodeUuid = data.uuid;
      })
      .catch(e => {
        throw e;
      });
  }
}
